const config = {
  v: 2,
  baseURL: "https://siteprint-manager.dallonses.dev/api/public/api/",
  baseURLStaging: "https://siteprint-manager-dev.dallonses.dev/api/public/api/",
  blogFetchURL: process.env.GATSBY_WEBENV === 'staging' ?
    "https://siteprint-manager-dev.dallonses.dev/api/public/public/dynamic/blog?language=en" :
    "https://siteprint-manager.dallonses.dev/api/public/public/dynamic/blog?language=en",
  scrollVideoUrl: process.env.GATSBY_WEBENV === 'staging' ? "https://siteprint-manager-dev.dallonses.dev/api/static-uploads/scrollVideo" :
    "https://siteprint-manager.dallonses.dev/api/static-uploads/scrollVideo",
  configEndpoint: "config",
  cloudfront: {
    baseURL: "https://dph062w68hx1r.cloudfront.net/",
    resized: "_resized",
  },
};

module.exports = config;
